import { useState, useRef, useEffect } from "react";

interface DropdownInputProps {
  options: string[];
  value_idx: number;
  onSelect?: (idx: number) => void;
  // เพิ่ม Prop สำหรับรับคำสั่งตอนเลื่อนสุด
  onReachBottom?: () => void; 
}

const DropdownInput: React.FC<DropdownInputProps> = ({
  options,
  value_idx,
  onSelect,
  onReachBottom,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  // 📌 ปิด dropdown เมื่อคลิกนอก component
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  // 📌 ฟังก์ชันตรวจจับการเลื่อน Scroll
  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    // เผื่อระยะขาดเหลือ 2px ป้องกันปัญหาเศษทศนิยมจากการซูมจอ
    if (scrollHeight - scrollTop <= clientHeight + 2) {
      if (onReachBottom) {
        onReachBottom();
      }
    }
  };

  return (
    <div ref={dropdownRef} className="relative text-sm">
      <div
        className="p-2 flex justify-between items-center border border-gray-nor rounded cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <p className="text-black truncate">{options[value_idx]}</p>
        <img src="/down-arrow.svg" alt="" className="w-3" />
      </div>

      {/* Dropdown List */}
      {open && options.length > 0 && (
        <div 
          className="absolute z-10 w-full overflow-y-auto max-h-36 shadow-lg rounded bg-white"
          onScroll={handleScroll} // ใส่ Event ตรงนี้
        >
          {options.map((opt, idx) => (
            <div
              key={opt}
              onClick={() => {
                onSelect?.(idx);
                setOpen(false);
              }}
              className="w-full p-2 text-gray border-b cursor-pointer hover:bg-green-light truncate"
            >
              {opt}
            </div>
          ))}
        </div>
      )}

      {/* No Data */}
      {open && options.length === 0 && (
        <div className="absolute z-10 text-center text-gray-nor w-full bg-white p-2 shadow-lg rounded">
          No Data
        </div>
      )}
    </div>
  );
};

export default DropdownInput;